import gql from 'graphql-tag'

export const updateJob = gql`
  mutation updateJob(
    $expected_close_date: String
    $start_date: String
    $description: String
    $name: String!
    $job_priority_id: Float
    $job_status_id: Float!
    $id: Float!
    $workspace_id: Float!
    $custom_attribute: [customAttributeValues!]!
  ) {
    updateJob(
      expected_close_date: $expected_close_date
      start_date: $start_date
      description: $description
      name: $name
      job_priority_id: $job_priority_id
      job_status_id: $job_status_id
      id: $id
      workspace_id: $workspace_id
      custom_attribute: $custom_attribute
    ) {
      status
      msg
      data
    }
  }
`
